import {Injectable} from "@angular/core";
import {ApiBaseService} from "@portal/api/api-base-service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Guid} from "guid-typescript";
import {SearchRequest} from "@portal/api/requests/search-request";
import {DtcBySystemAddRequest} from "@portal/api/sections/dtc-by-system/dtc-by-system-add-request";
import {DtcBySystemForm} from "@portal/api/sections/dtc-by-system/dtc-by-system-form";
import {Success, SuccessList} from "@portal/api/api-response";
import {DtcBySystemResponse} from "@portal/api/sections/dtc-by-system/dtc-by-system-response";
import {ApiKeyListResponse} from "@portal/api/sections/api-keys/api-key-list-response";
import {parseObjectToQueryString} from "@portal/shared/utils";
import {ListService} from "@portal/api/services/interfaces/list.service";
import {ListResponse} from "@portal/api/responses/api-response";
import {
    TuningConfigurationListResponse
} from "@portal/api/responses/tuning-configuration/tuning-configuration-list-response";

@Injectable({
    providedIn: 'root'
})

export class DtcBySystemService extends ApiBaseService implements ListService {
    controller = 'dtcs-by-system';

    constructor(public http: HttpClient) {
        super(http);
    }

    add(obj: DtcBySystemAddRequest): Observable<Success<boolean>> {
        return this.post<Success<boolean>, DtcBySystemAddRequest>(obj, this.controller);
    }

    update(obj: DtcBySystemForm): Observable<Success<boolean>> {
        return this.put<Success<boolean>, DtcBySystemForm>(obj, this.controller);
    }

    getFormEdit(id: Guid): Observable<Success<DtcBySystemForm>> {
        return this.get<Success<DtcBySystemForm>>(this.controller + `/form/${id}`);
    }

    list<DtcBySystemResponse>(obj: SearchRequest): Observable<ListResponse<DtcBySystemResponse[]>> {
        return this.post<ListResponse<DtcBySystemResponse[]>, SearchRequest>(obj, this.controller + `/list`);
    }

    deleteDTC(id: Guid): Observable<Success<boolean>> {
        return this.delete<Success<boolean>>(`${this.controller}/${id}`);
    }

    getAll(): Observable<SuccessList<DtcBySystemForm>> {
        return this.get<SuccessList<DtcBySystemForm>>(this.controller + `/getALl`);
    }
}

